module.exports = __webpack_public_path__ + "img/巡检.458b154e.jpg";